import { Users, Database, Settings, Zap } from "lucide-react";
import { NichePage } from "./NichePageTemplate";

const sections = [
  {
    icon: Users,
    name: "Client Operations",
    items: [
      "Client onboarding", "Client information management", "Follow-up",
      "Documentation", "Project coordination"
    ]
  },
  {
    icon: Database,
    name: "CRM",
    items: [
      "Lead management", "Client pipeline", "CRM organization",
      "Database management", "Automated workflows"
    ]
  },
  {
    icon: Settings,
    name: "Project Operations",
    items: [
      "Task management", "Workflow coordination", "Reporting",
      "Internal processes", "SOPs"
    ]
  },
  {
    icon: Zap,
    name: "Automation",
    items: [
      "Client workflows", "Notifications", "Lead routing",
      "Task automation", "Integrations"
    ]
  }
];

export const AgenciesPage = () => (
  <NichePage
    title="Agencies & Professional Services"
    subtitle="Systems and operational infrastructure for client-driven businesses."
    sections={sections}
  />
);
